import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomFormValidators } from '@spartacus/storefront';
import { PlaceOrderForm } from '../uig-checkout.models';
import { UigCheckoutService } from '../uig-checkout.service';
import {Address} from '@spartacus/core';

@Component({
    selector: 'app-uig-direct-delivery',
    templateUrl: './uig-direct-delivery.component.html',
    styleUrls: ['./uig-direct-delivery.component.scss'],
    standalone: false
})
export class UigDirectDeliveryComponent implements OnInit {

  createMode: boolean;

  placeOrderForm: PlaceOrderForm;
  directDeliveryForm: UntypedFormGroup = this.fb.group({
    fullName: ['', Validators.required],
    nameSuffix: [''],
    street: ['', Validators.required],
    postalCode: ['', Validators.required],
    town: ['', Validators.required],
    email: ['', [Validators.required, CustomFormValidators.emailValidator]],
    phone: ['', Validators.required]
  });

  constructor(
    private fb: UntypedFormBuilder,
    public modal: NgbActiveModal,
    protected uigCheckoutService: UigCheckoutService) {}

  ngOnInit(): void {
    this.placeOrderForm = this.uigCheckoutService.getCurrentPlaceOrderForm();

    const address = this.placeOrderForm.directDeliveryAddress;
    if (address) {
      this.directDeliveryForm.get('fullName').setValue(address.firstName);
      this.directDeliveryForm.get('nameSuffix').setValue(address.nameSuffix);
      this.directDeliveryForm.get('street').setValue(address.line1);
      this.directDeliveryForm.get('postalCode').setValue(address.postalCode);
      this.directDeliveryForm.get('town').setValue(address.town);
      this.directDeliveryForm.get('email').setValue(address.email);
      this.directDeliveryForm.get('phone').setValue(address.phone);
    }
    else {
      this.createMode = true;
    }
  }

  onSubmit(): void {
    if (this.directDeliveryForm.valid) {
      let address = this.placeOrderForm.directDeliveryAddress;
      if (!address) {
        address = {} as Address;
        this.placeOrderForm.directDeliveryAddress = address;
      }
      address.firstName = this.directDeliveryForm.get('fullName').value;
      address.nameSuffix = this.directDeliveryForm.get('nameSuffix').value;
      address.line1 = this.directDeliveryForm.get('street').value;
      address.postalCode = this.directDeliveryForm.get('postalCode').value;
      address.town = this.directDeliveryForm.get('town').value;
      address.email = this.directDeliveryForm.get('email').value;
      address.phone = this.directDeliveryForm.get('phone').value;

      this.modal.close(true);
    } else {
      this.directDeliveryForm.markAllAsTouched();
    }
  }

}
